import axios from 'axios';
import http from 'core/services/http';
import Config from 'core/config';
import isObject from 'lodash/isObject';

const toQueryString = (obj) => {
  const params = Object.keys(obj).map(key =>
    `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
  return params.length ? params.join('&') : '';
};

class TcRenewalService {
  static getTcCycle(id) {
    return http.get(`${Config.apiUrl}/testcentercycle/${id}`);
  }

  static getCoordinatorAgreement(userId, status, cycleId) {
    return http.get(`${Config.apiUrl}/personnel/${userId}/allterms/${status}?cycleId=${cycleId}`);
  }

  static acceptAgreement(userId, termId) {
    return http.post(`${Config.apiUrl}/personnel/${userId}/terms/${termId}/accept`);
  }

  static updateTestCenterStatus(id, status) {
    return http.put(`${Config.apiUrl}/testcentercycle/${id}`, status);
  }

  static getContactTypes() {
    return http.get(`${Config.apiUrl}/contacttypes`);
  }

  static getTcCycleContacts(tcCycleId, contactTypeId) {
    return http.get(`${Config.apiUrl}/testcentercycle/${tcCycleId}/contacts/${contactTypeId}`);
  }

  static setTcCycleContact(contact) {
    return http.post(`${Config.apiUrl}/testcentercyclecontact`, contact);
  }

  static updateTcCycleContact(contact) {
    return http.put(`${Config.apiUrl}/testcentercyclecontact`, contact);
  }

  static removeTcCycleContact(contactId) {
    return http.delete(`${Config.apiUrl}/testcentercyclecontact/${contactId}`);
  }

  static updateTCCycle(cycleData) {
    return http.put(`${Config.apiUrl}/testcentercycledto`, cycleData);
  }

  static updateTCCycleData(cycleData) {
    return http.put(`${Config.apiUrl}/testcentercycle`, cycleData);
  }

  static getDigitalAssessmentQuestions(tcCycleId) {
    return http.get(`${Config.apiUrl}/testcentercycle/${tcCycleId}/cyclefields`);
  }

  static getDigitalAssessmentAnswers(tcCycleId) {
    return http.get(`${Config.apiUrl}/testcentercycle/${tcCycleId}/testcentercyclefields`);
  }

  static setDigitalAssessmentAnswer(data) {
    return http.put(`${Config.apiUrl}/testcentercyclefield`, data);
  }

  static removeDigitalAssessmentAnswer(id) {
    return http.delete(`${Config.apiUrl}/testcentercyclefield/${id}`);
  }

  static getAvailableRenewalDates(tcCycleId) {
    return http.get(`${Config.apiUrl}/testcentercycle/${tcCycleId}/availablerenewaldates`);
  }

  static getTcCycleEvents(tcCycleId) {
    return http.get(`${Config.apiUrl}/testcentercycle/${tcCycleId}/events`);
  }

  static setTcCycleEvents(tcCycleId, data) {
    return http.post(`${Config.apiUrl}/testcentercycle/${tcCycleId}/events`, data);
  }
}

export default TcRenewalService;
